// extracted by mini-css-extract-plugin
export default {"btnGroup":"ImageEditorComponent_btnGroup__DH723","cropContainer":"ImageEditorComponent_cropContainer__DyVFv"};